var cambiaImagen = function (imagenes, i) { return function () {
    imagenes.forEach(function (img, j) { return img.hidden = i !== j; });
}; };
var dondeEncontrar = function () {
    Array.from(document.querySelectorAll('.donde_encontrar')).forEach(function (div) {
        var enlaces = Array.from(div.querySelectorAll('.donde-encontrar__tiendas a'));
        var imagenes = Array.from(div.querySelectorAll('.donde-encontrar__imagen'));
        enlaces.forEach(function (e, i) {
            e.addEventListener('mouseenter', cambiaImagen(imagenes, i));
            e.addEventListener('focus', cambiaImagen(imagenes, i));
            e.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
            });
        });
    });
};
export default dondeEncontrar;
